<template>
  <div class="atividades-monitoramentoescala ml-4 mr-4" >
      <b-form> 

          <b-row>
              <b-col cols="1" class="mt-2 pr-4" >
                  <b-form-group label="" label-for="tabela-foto">
                    <b-img                         
                        class="mb-2" 
                        v-model="operador.foto"                         
                        v-bind="mainProps" rounded alt="Foto"
                        
                        :src="operador.foto"
                    >
                    </b-img>
                  </b-form-group>
                  
              </b-col>  
             
              <b-col>

                <!-- NOME -->     
                <b-row >
                    <b-col cols=3 class="mt-3 ">
                        <b-form-input id="fot-nome" 
                            type="text" 
                            readonly                       
                            v-model="operador.nome"                         
                            placeholder="Nome funcionário" 
                        />                        
                    </b-col>

                    <b-col cols=1 class="mt-3 ">
                        <b-form-input id="fot-admissao" 
                            type="text" 
                            readonly                       
                            v-model="operador.admissao"
                            v-mask="'DD/MM/YYYY'"
                            placeholder="Admissão" 
                        />                        
                    </b-col>                                                                  
                </b-row>


                <!-- FUNÇÃO e CHN -->     
                <b-row >
                   
                    <b-col cols=2 class="mt-2">
                        <b-form-input id="fot-funcao" 
                            type="text"   
                            readonly                     
                            v-model="operador.funcao"                         
                            placeholder="Função" 
                        />                        
                    </b-col>

                    <b-col cols=1 class="mt-2">                        
                        <b-form-input id="fot-celular" only
                            type="text"
                            readonly   
                            v-mask="'#####-###'"                     
                            v-model="operador.celular"                         
                            placeholder="Celular" 
                        />
                    </b-col>                       

                    <b-col cols=1 class="mt-2">                        
                        <b-form-input id="fot-cnh" 
                            type="text"  
                            readonly                      
                            v-model="operador.cnh_cat"                         
                            placeholder="CNH" 
                        />
                    </b-col>   
                                                                  
                </b-row>

                <!-- RE e CELULAR -->     
                <b-row >
                    <b-col cols=1 class="mt-4">
                        <b-form-input id="fot-re" 
                            type="text"
                            required                        
                            v-model="operador.re" 
                            @keyup.enter="loadOperador()"                        
                            placeholder="1818" 
                        />                        
                    </b-col> 
                    
                    <b-col cols=2 class="mt-4">
                        <div>   
                                <b-form-datepicker id="esc_data_servico"  required v-model="data_operacao"  placeholder="Selecione uma data" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                            </div>                     
                    </b-col>                 


                    <b-col cols=1 class="mt-4">
                    <b-button size="sm" variant="primary" class="mr-2 mt-2" :disabled="carregando" @click="carregando = true,loadEscalaServico()">
                      <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                    </b-button>                      
                </b-col>
             
                </b-row>

                            


              </b-col>              
          </b-row>

          
    </b-form>
    <hr>
    <b-table small hover striped sticky-header="618px"  :items="escala" :fields="fields">                           
        
    </b-table>      
    </div>
</template>

<script>
import { baseApiUrl,showError } from '@/global'
import axios from 'axios'
import moment from 'moment'



export default {    
    name: 'TraAtividadesProgramadasRealizadas',

    data: function() {
        return {
            mode: 'save',
            carregando: false,
            operadores:{},
            operador: [],            
            escala:[],
            data_operacao: '',




            mainProps: { blankColor: '#777', width: 157, height: 161, class: 'm1' },


            
            fields: [
                

                { key: 'data_servico', label: 'Data Servico', sortable: true, formatter: (value, key, escala) => {
                    return moment(escala.data_servico).format('DD/MM/YYYY');} },
                { key: 'linha', label: 'Linha', sortable: true },
                { key: 'tabela', label: 'Tabela', sortable: true },
                { key: 'loc_ini_linha', label: 'Linha inicio', sortable: true },                
                
                { key: 'hor_ini_linha', label: ' Linha inicio ', sortable: true }, 
                { key: 'hor_ter_linha', label: 'Linha término', sortable: true },
                { key: 'carro', label: 'Carro', sortable: true },
                { key: 'modalidade', label: 'Modalidade', sortable: true },

                { key: 'mot_re', label: 'Mot RE', sortable: true },
                { key: 'mot_loc_pegada', label: 'Motorista local pegada', sortable: true },
                { key: 'mot_loc_largada', label: 'Motorista local largada', sortable: true },

                { key: 'mot_jor_ini', label: 'Mot Jor inicio', sortable: true, formatter: (value, key, escala) => {
                    return moment(escala.mot_jor_ini).format('DD/MM/YYYY HH:mm').replace('Data inválida','-');} },

                { key: 'mot_jor_fim', label: 'Mot Jor Fim', sortable: true, formatter: (value, key, escala) => {
                    return moment(escala.mot_jor_fim).format('DD/MM/YYYY HH:mm').replace('Data inválida','-');} },



                { key: 'cob_re', label: 'Cob RE', sortable: true },
                { key: 'cob_loc_pegada', label: 'Cobrador local pegada', sortable: true },
                { key: 'cob_loc_largada', label: 'Cobrador local largada', sortable: true },

                { key: 'cob_jor_ini', label: 'Cob Jor inicio', sortable: true, formatter: (value, key, escala) => {
                    return moment(escala.mot_jor_ini).format('DD/MM/YYYY HH:mm').replace('Data inválida','-');} },

                { key: 'cob_jor_fim', label: 'Cob Jor Fim', sortable: true, formatter: (value, key, escala) => {
                    return moment(escala.mot_jor_fim).format('DD/MM/YYYY HH:mm').replace('Data inválida','-');} },

                { key: 'cob_jor_ini', label: 'Cob Jor inicio', sortable: true },
                { key: 'cob_jor_fim', label: 'Cob Jor Fim', sortable: true }




                
            ]
        }        
    },


    methods: {

        async loadOperador() { 
            let corpo = {                             
            "re": `${this.operador.re}`                      
            }; 
            
          const url = `${baseApiUrl}/escala/consulta/`
          axios.post(url,corpo).then(res => { this.operador = res.data })   
                      this.carregando = false;       
                      this.escala = []
        },  

        async loadEscalaServico() {                                 
            let corpo = {                
            "id_operador": `${this.operador.id_funcionario_erp}` ,                     
            "data_servico": `${this.data_operacao}`                      
          }; 
          const url = `${baseApiUrl}/escala/consulta/servico/`
          axios.post(url,corpo)
          .then(res => {
            this.carregando = false;               
            this.escala = res.data 
            })          
        .catch(showError)
            
        }, 



        
       
    },

    mounted() { 
       // this.loadFormatarData()
       //this.loadOperador()           
       //this.loadEscalaServico()
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.table{
    font-size: 0.7em;
}
</style>

